"use client";

import { Toaster } from "sonner";

export function ToastProvider() {
	return (
		<Toaster
			position="top-right"
			toastOptions={{
				style: {
					background: "#fff",
					color: "#333",
					border: "1px solid #eaeaea",
					borderRadius: "0.625rem",
				},
				duration: 4000,
			}}
		/>
	);
}
